// tabs
export const tabs = [
  { id: 0, info: "Transactions" },
  { id: 1, info: "Settlements" },
  { id: 2, info: "Performance" },
  { id: 3, info: "Terminal Health" },
  { id: 4, info: "Bank Statement" },
];

export const tabDetails = [
  {
    id: 0,
    info: "Settled Amount",
    amount: "#40,000,000",
    image: "dollar-circle.svg",
  },
  {
    id: 1,
    info: "Transaction Amount",
    amount: "#35,000,000",
    image: "money-recieve.svg",
  },
  { id: 2, info: "Charges", amount: "#5,000,000", image: "money-send.svg" },
];

// chart
export const chartData = [
  { id: 0, date: "7th Oct", totalSettlement: "1000" },
  { id: 1, date: "8th Oct", totalSettlement: "2000" },
  { id: 2, date: "9th Oct", totalSettlement: "1000" },
  { id: 3, date: "10th Oct", totalSettlement: "500" },
  { id: 4, date: "11th Oct", totalSettlement: "1000" },
  { id: 5, date: "12th Oct", totalSettlement: "1500" },
];

// table
export const tableData = [
  {
    id: 0,
    time: "12:30pm",
    transactionAmount: "#25,000",
    charges: "#25",
    settledAmount: "#29,950",
    transactionId: "ZB12345678FF",
  },
  {
    id: 1,
    time: "12:25pm",
    transactionAmount: "#25,000",
    charges: "#25,000",
    settledAmount: "#25,000",
    transactionId: "ZB12345678FF",
  },
  {
    id: 2,
    time: "12:20pm",
    transactionAmount: "#25,000",
    charges: "#25,000",
    settledAmount: "#25,000",
    transactionId: "ZB12345678FF",
  },
  {
    id: 3,
    time: "12:15pm",
    transactionAmount: "#25,000",
    charges: "#25,000",
    settledAmount: "#25,000",
    transactionId: "ZB12345678FF",
  },
];

// sidebar
export const sidebarData = [
  {
    id: 0,
    value: "Dashboard",
    icon: "dashboardIcon.svg",
  },
  {
    id: 1,
    value: "Transactions",
    dropdown: "sidebardownarrow.svg",
    icon: "transactions.svg",
  },
  {
    id: 2,
    value: "Terminal Health",
    dropdown: "sidebardownarrow.svg",
    icon: "terminal.svg",
  },
  {
    id: 3,
    value: "Settlement",
    dropdown: "sidebardownarrow.svg",
    icon: "settlements.svg",
  },
  {
    id: 4,
    value: "Performance",
    dropdown: "sidebardownarrow.svg",
    icon: "performance.svg",
  },
  { id: 5, value: "Bank Statement", icon: "statements.svg" },
  { id: 6, value: "My Terminals", icon: "terminals.svg" },
  { id: 7, value: "Message Center", icon: "message.svg" },
  {
    id: 8,
    value: "Settings",
    dropdown: "sidebardownarrow.svg",
    icon: "settings.svg",
  },
  { id: 9, value: "Reconciliation", icon: "reconcilation.svg" },
  { id: 10, value: "Dispute Management", icon: "dispute.svg" },
];

